module.exports = __webpack_public_path__ + "static/media/vertex-11002x.4246d850.jpg";